import { JSX, useState, useEffect } from 'react'

import { DatePicker, Portal } from '@chakra-ui/react'


import * as locally from '@/lib/locally.js'
import * as detective from '@/lib/detective.js'





export function format (value: Date): string
{
	return locally.date(value, { format: 'YYYY.MM.DD' })

}

export function parse (value: unknown): undefined | Date
{
	if (detective.is_date(value) )
	{
		return value

	}

	else if (detective.is_date_string(value) )
	{
		return new Date(value)

	}

	return undefined

}




export type Tprops<T> = {
	value: T
	change(value: T): void

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Single
(props: Tprops<null | string>): JSX.Element
{
	let [value, update_value] = useState<undefined | Date>()

	let on_change = (v: Date): void =>
	{
		props.change(v.toISOString() )

	}

	useEffect(
		() =>
		{
			update_value(parse(props.value) )

		},

		[props.value],

	)


	return (
		<></>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Between
(props: Tprops< detective.Between<string> >): JSX.Element
{
	let [value, update_value] = useState<Date[]>([])

	let on_change = (v: Date[]): void =>
	{
		props.change(
			v.map(vv => vv.toISOString() ) as detective.Between<string>,

		)

	}

	useEffect(
		() =>
		{
			update_value(
				props.value.map(parse).filter(Boolean) as Date[],

			)

		},

		[props.value],

	)


	return (
		<></>


	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Range
(props: Tprops< detective.Range<string> >): JSX.Element
{
	let on_change = (v: detective.Between<string>): void =>
	{
		if (v.length > 1)
		{
			props.change(v as detective.Range<string>)

		}


	}

	return (
		<></>

	)

}
